function Signer(authType, validate, success) {
  let self = this
  let signingErrorMessagesTemplate = Handlebars.compile($('#signing-error-messages-partial').html())

  function serverError() {
    showTechnicalError(Labels['signingFailed'])
  }

  function showTechnicalError(message) {
    Logger.error('Signer error: ' + message);
    $('#signing-error-messages').empty().append(signingErrorMessagesTemplate({message: message}))
  }

  self.sign = function() {
    $('#signing-error-messages').empty()
    switch (authType) {
      case 'ID_CARD': {
        new IdCardSigner(validate).sign()
        break
      }
      case 'MOBILE_ID': {
        new MobileIdSigner(validate).sign()
        break
      }
      case 'SMART_ID': {
        new SmartIdSigner(validate).sign()
        break
      }
    }
  }

  function IdCardSigner(validate) {
    function signingError(error) {
      if (error instanceof Error) showTechnicalError(Labels[error.message] || error.message)
    }

    function getContainerHash(certificate, documentToSign) {
      let params = Object.assign({certificate: toPemCertificate(certificate.certificate)}, documentToSign)
      return $.post('/application/create/idcard', params)
        .fail(serverError)
    }

    function sendSignature(signature) {
      return $.post('/application/sign/idcard', signature)
        .fail(serverError)
    }

    function getCertificate() {
      return webeid.getSigningCertificate({lang: 'et'})
    }

    function sign(response, certificate) {
      Logger.info('Signing ' + JSON.stringify(response) + ' with ID Card certificate');
      return webeid.sign(certificate, response.containerHash, 'SHA-256', {lang: 'et'})
    }

    this.sign = function() {
      let idCardCert;
      let documentToSign;

      validate()
        .then(function(preparedDocument) {
          Logger.info('Document to sign: ' + JSON.stringify(preparedDocument));
          documentToSign = preparedDocument
        })
        .then(getCertificate)
        .then(function (certificate) {
          idCardCert = certificate.certificate
          Logger.info('ID Card certificate received');
          return getContainerHash(certificate, documentToSign)
        })
        .then(function (response) {
          Logger.info('Container hash received: ' + JSON.stringify(response));
          return sign(response, idCardCert)
        })
        .then(sendSignature)
        .then(function(signedDocument) {return Object.assign(documentToSign, signedDocument)})
        .done(success)
        .then($.noop, signingError)
    }
  }


  function disableSubmit() {
    $('#submit').attr('disabled', 'disabled')
  }

  function enableSubmit() {
    $('#submit').removeAttr('disabled')
  }

  function MobileIdSigner(validate) {
    function showChallengeAndWait(preparedDocument) {
      return $.post('/application/create/mobileid', preparedDocument)
        .done(function (result) {
          $('#challenge').text(Labels['mid-challenge'] + ' ' + result.challenge).show()
          disableSubmit()
        })
        .fail(function () {
          serverError()
          enableSubmit()
        })
    }

    function waitSignature(params) {
      return $.ajax({
        type: 'post',
        url: '/application/sign/mobileid'
      })
        .fail(function (xhr) {
          enableSubmit()
          if (xhr.responseJSON && xhr.responseJSON.reason) {
            showTechnicalError(Labels[xhr.responseJSON.reason] || xhr.responseJSON.reason)
          }
          else {
            serverError()
          }
        }).always(function () {
          $('#challenge').hide()
        })
    }

    this.sign = function() {
      let documentToSign

      validate()
        .done(function(preparedDocument) {documentToSign = preparedDocument})
        .then(showChallengeAndWait)
        .then(waitSignature)
        .then(function(signedDocument) {return Object.assign(documentToSign, signedDocument)})
        .done(success)
    }
  }

  function SmartIdSigner() {
    function showChallengeAndWait(preparedDocument) {
      return $.post('/application/create/smart-id', preparedDocument)
        .done(function (result) {
          $('#challenge').text(Labels['login-smartId-challenge'] + ' ' + result.challenge).show()
          disableSubmit()
        })
        .fail(function () {
          serverError()
          enableSubmit()
        })
    }

    function waitSignature() {
      return $.ajax({
        type: 'post',
        url: '/application/sign/smart-id'
      })
        .fail(function (xhr) {
          enableSubmit()
          if (xhr.responseJSON && xhr.responseJSON.reason) {
            showTechnicalError(Labels[xhr.responseJSON.reason])
          }
          else {
            serverError()
          }
        }).always(function () {
          $('#challenge').hide()
        })
    }

    this.sign = function() {
      let documentToSign

      validate()
        .done(function(preparedDocument) {documentToSign = preparedDocument})
        .then(showChallengeAndWait)
        .then(waitSignature)
        .then(function(signedDocument) {return Object.assign(documentToSign, signedDocument)})
        .done(success)
    }
  }
}

function toPemCertificate(s) {
  return "-----BEGIN CERTIFICATE-----\n" + s + "\n-----END CERTIFICATE-----";
}